import React, { useEffect, useState } from "react";
import "./OrderHistory.css";
import { Form, Table } from "react-bootstrap";
import Empty_Folder_Lottie from "../../../animation/empty_folder_lottie/Empty_Folder_Lottie";
import Select, { components } from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown } from "@fortawesome/free-solid-svg-icons";
import { getHistoryOfOrder } from "../../../../utils/apis/performance/performance";
import CustomPaginate from "../../../common_components/custompaginate/CustomPaginate";

const OrderHistory = () => {
  const [activeTab, setActiveTab] = useState("buy");

  const [name, setName] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const [orderHistory, setOrderHistory] = useState({});
  const getOrderHistory = async (page, perPage) => {
    const res = await getHistoryOfOrder(activeTab, page, perPage);
    if (res?.success) {
      setOrderHistory(res.data);
    }
  };

  const handlePageChange = async (page) => {
    setCurrentPage(page);
    await getOrderHistory(name, page, perPage);
  };

  useEffect(() => {
    getOrderHistory();
  }, [activeTab]);

  return (
    <section className="OrderHistory Transaction_History ">
      <div className="content_holder">
        <div className="tabs_btn_holder">
          <button
            className={`gray_btn ${activeTab === "open" ? "active" : ""}`}
            type="button"
            onClick={() => setActiveTab("buy")}
          >
            Buy Order
          </button>

          <button
            className={`gray_btn ${activeTab === "close" ? "active" : ""}`}
            type="button"
            onClick={() => setActiveTab("sell")}
          >
            Sell Order
          </button>
        </div>
        {/* {activeTab === "closed" ? ( */}
        <div className="closed_order_div">
          <div class="table-responsive table_holder">
            <table class="table">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Company</th>
                  <th>{activeTab} Price</th>
                  <th>Quantity</th>
                  <th>Amount</th>
                  <th>Type</th>
                  <th>Order Status</th>
                  <th>Date</th>
                  <th>Time</th>
                </tr>
              </thead>
              <tbody>
                {orderHistory?.data?.length > 0 ? (
                  orderHistory?.data.map((val, index) => (
                    <tr key={index}>
                      <td>
                        {(orderHistory?.current_page - 1) *
                          orderHistory?.per_page +
                          index +
                          1}
                      </td>

                      <td>{val?.Company?.name}</td>
                      <td>
                        ${" "}
                        {val?.quantity
                          ? (val?.amount / val?.quantity).toFixed(2)
                          : "0.00"}
                      </td>

                      <td>{val?.quantity}</td>
                      <td>$ {val?.amount}</td>
                      <td> {val?.type}</td>
                      <td> {val?.order_status}</td>
                      <td>
                        {new Date(val?.createdAt).toLocaleDateString("en-GB")}
                      </td>
                      <td>
                        {new Date(val?.createdAt).toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="18" className="text-center fw-bold">
                      <div className="no_data_div">
                        <Empty_Folder_Lottie />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <CustomPaginate
              currentPage={orderHistory?.current_page}
              totalPages={orderHistory?.total_pages}
              handlePageChange={handlePageChange}
            />
            <ul class="pagination"></ul>
          </div>
        </div>
        {/* ) : (
        <div className="closed_order_div">
          <div className="amition_holder">
        
          </div>
          <p className="note_text">You Don't have Open order in this account</p>
        </div>
        )} */}
      </div>
    </section>
  );
};

export default OrderHistory;
